import React, { VFC, useState } from 'react';
import { TFunction } from 'react-i18next';
import { Button, Typography, makeStyles, ButtonProps } from '@dxb-web-ui-framework/design-system';
import { GenericDialog } from '../../../../content-composer/src/components/Generic/GenericDialog/GenericDialog';
import { DialogAction } from '../../../../content-composer/src/components/Generic/types';

export interface RequestDealerRateProps {
  t: TFunction;
  isLoading: boolean;
  isDisabled?: boolean;
  onRequestDealerUserSelection?: React.MouseEventHandler<HTMLButtonElement>;
  externalButtonProps?: ButtonProps;
}

const useStyles = makeStyles(theme => ({
  dialogContent: {
    marginBottom: theme.spacing(5),
  },
}));

const RequestDealerRate: VFC<RequestDealerRateProps> = ({
  t,
  isLoading,
  isDisabled,
  onRequestDealerUserSelection = () => {},
  externalButtonProps,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onToggleDialog = () => {
    setIsOpen(prev => !prev);
  };

  const onRequestDealerRateWrapper: React.MouseEventHandler<HTMLButtonElement> = e => {
    onToggleDialog();
    onRequestDealerUserSelection(e);
  };

  const dialogActions: DialogAction[] = [
    {
      onClick: onToggleDialog,
      label: t('fundsTransferPage.RequestDealerRate.cancelButton.Label'),
      color: 'primary',
      variant: 'outlined',
    },
    {
      onClick: onRequestDealerRateWrapper,
      label: t('fundsTransferPage.RequestDealerRate.confirmButton.Label'),
      color: 'primary',
      variant: 'contained',
    },
  ];

  const classes = useStyles();

  return (
    <>
      <Button
        variant='text'
        title={t('fundsTransferPage.RequestDealerRate.Generic.Text')}
        {...externalButtonProps}
        disabled={isLoading || isDisabled}
        onClick={onToggleDialog}>
        {externalButtonProps?.title ? externalButtonProps.title : t('fundsTransferPage.RequestDealerRate.Generic.Text')}
      </Button>
      <GenericDialog
        fullwidth
        isError={false}
        isLoading={false}
        isConfirmationResponsiveDialog={true}
        dialogContentClassName={classes.dialogContent}
        isDialogOpen={isOpen}
        onToggleDialog={onToggleDialog}
        stickDrawerTitleToLeft={true}
        disableMobileDrawerHeight={true}
        dialogTitle={t('fundsTransferPage.RequestDealerRate.Generic.Text')}
        loaderVerticalSpacing='large'
        dialogContent={<Typography variant='body2'>{t('fundsTransferPage.RequestDealerRate.Content.Text')}</Typography>}
        isSuccess={false}
        dialogActions={dialogActions}
      />
    </>
  );
};

export { RequestDealerRate };
